import { render, staticRenderFns } from "./createCust2Family.vue?vue&type=template&id=1c4ac1f0&scoped=true"
import script from "./createCust2Family.vue?vue&type=script&lang=js"
export * from "./createCust2Family.vue?vue&type=script&lang=js"
import style0 from "./createCust2Family.vue?vue&type=style&index=0&id=1c4ac1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4ac1f0",
  null
  
)

export default component.exports